import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from './Card'
import { ProductWithAddOns } from 'components/enrollForm/enrollFormTypes'
import { getProductListDisplayInfo } from 'helpers/getProductListDisplayInfo'
import { numberFormatter } from 'helpers'
import { PacketIcon, plusIcon } from 'assets'
import { colors } from 'styles/colors'

type CardProductProps = {
    product: Partial<ProductWithAddOns>
    onClick?: () => void
    showDetails?: boolean
    isAddOn?: boolean
}

export const CardProduct = ({
    product,
    onClick,
    showDetails = true,
    isAddOn = false
}: CardProductProps) => {
    const { t } = useTranslation()
    const nbSelectedUnits = product.nbSelectedUnits || 0
    const isSelected = nbSelectedUnits > 0
    let selectedClassName = isSelected ? 'card-product--selected' : ''
    if (isAddOn && selectedClassName !== '') {
        selectedClassName += '--add-on'
    }

    const { isMultiSize, sizeDisplay, listPrice, hidePrice } =
        getProductListDisplayInfo(product)

    return (
        <Card onClick={onClick} className="card--product-parent">
            <div
                data-testid={`card-product-${product.sf_id}`}
                className={`card-product card-product--catalog ${selectedClassName}`}
                aria-label={'card-product'}
            >
                {isSelected ? (
                    <div
                        className="card-product-units"
                        data-testid={`card-product-units-${product.sf_id}`}
                    >
                        {nbSelectedUnits}
                    </div>
                ) : (
                    <div
                        className="card-product__add"
                        data-testid={`card-product-add-${product.sf_id}`}
                        aria-hidden="true"
                    >
                        {plusIcon({
                            color: colors.white,
                            width: '18',
                            height: '18'
                        })}
                    </div>
                )}
                {product.image_url && (
                    <img
                        src={product.image_url}
                        alt={product.name}
                        className="card-product-picture card-product__picture"
                        onError={(
                            event: React.SyntheticEvent<HTMLImageElement, Event>
                        ) =>
                            ((event.target as HTMLImageElement).style.display =
                                'none')
                        }
                    ></img>
                )}
                {showDetails && (
                    <div className="card-product__details">
                        <div className="card-product-name card-product__name">
                            <span className="card-product__name-text">
                                {product.name}
                            </span>
                        </div>
                        <div className="card-product__sub">
                            {isMultiSize ? (
                                <div
                                    className="card-product__multi-size"
                                    data-testid={`card-product-multi-size-${product.sf_id}`}
                                    aria-label={t('enrollment.multipleSizes')}
                                >
                                    <span
                                        className="card-product__multi-size-layer card-product__multi-size-layer--back"
                                        aria-hidden="true"
                                    >
                                        <PacketIcon
                                            color={colors.primary}
                                            width="14"
                                            height="14"
                                        />
                                    </span>
                                    <span
                                        className="card-product__multi-size-layer card-product__multi-size-layer--mid"
                                        aria-hidden="true"
                                    >
                                        <PacketIcon
                                            color={colors.primary}
                                            width="14"
                                            height="14"
                                        />
                                    </span>
                                    <span
                                        className="card-product__multi-size-layer card-product__multi-size-layer--front"
                                        aria-hidden="true"
                                    >
                                        <PacketIcon
                                            color={colors.primary}
                                            width="14"
                                            height="14"
                                        />
                                    </span>
                                </div>
                            ) : (
                                <>
                                    {sizeDisplay && (
                                        <div
                                            className="card-product__size"
                                            data-testid={`card-product-size-${product.sf_id}`}
                                        >
                                            {sizeDisplay}
                                        </div>
                                    )}
                                    {listPrice !== undefined && (
                                        <div
                                            className="card-product__price"
                                            data-testid={`card-product-price-${product.sf_id}`}
                                        >
                                            {numberFormatter(
                                                listPrice,
                                                'CFA',
                                                hidePrice
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </Card>
    )
}
